import React from "react";
import { Message, toaster } from "rsuite";
import UserDto from "../interfaces/userDto";

const api = process.env.REACT_APP_API_URL ?? "http://localhost:8080";

export const getAllUsers = async (
  page: number,
  limit: number,
  query?: string,
  sortType?: string,
  sortColumn?: string
) => {
  return await fetch(
    `${api}/api/users?page=${page - 1}&size=${limit}${
      query !== "" && query !== undefined ? `&query=${query}` : ""
    }${
      sortType !== undefined &&
      sortType !== null &&
      sortColumn !== undefined &&
      sortColumn !== null
        ? `&sort[${sortColumn}]=${sortType}`
        : ""
    }
    `,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": `${localStorage.getItem("accessToken")}`,
      },
    }
  )
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error(`Something went wrong, ${JSON.stringify(res)}`);
      }
    })
    .catch((e) => {
      throw new Error(e);
    });
};

export const updateUser = async (id: number, body: UserDto) => {
  try {
    const user = await fetch(`${api}/api/users/${id}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": `${localStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify(body),
    });

    if (user.ok) {
      const data = await user.json();
      toaster.push(
        <Message showIcon type='success' header='Erfolgreich'>
          Der User {data.name} wurde erfolgreich gespeichert.
        </Message>
      );
    }
  } catch (e) {
    console.log(e);
    toaster.push(
      <Message showIcon type='error' header='Fehlgeschlagen'>
        Leider ist beim Speichern des Users etwas schiefgelaufen.
      </Message>
    );
    return;
  }
};

export const deleteUser = async (id: number) => {
  try {
    const deleteUser = await fetch(`${api}/api/users/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": `${localStorage.getItem("accessToken")}`,
      },
    });
    if (deleteUser.ok) {
      const data = await deleteUser.json();
      toaster.push(
        <Message showIcon type='success' header='Erfolgreich'>
          Der User {data.name} wurde erfolgreich gelöscht.
        </Message>
      );
    }
  } catch (e) {
    console.log(e);
    toaster.push(
      <Message showIcon type='error' header='Fehlgeschlagen'>
        Leider ist beim Löschen des Users etwas schiefgelaufen.
      </Message>
    );
    return;
  }
};

export const createUser = async (body: UserDto) => {
  return await fetch(`${api}/api/auth/signup`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": `${localStorage.getItem("accessToken")}`,
    },
    body: JSON.stringify(body),
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error(`Something went wrong, ${JSON.stringify(res)}`);
      }
    })
    .catch((e) => {
      throw new Error(e);
    });
};
